import React from 'react'
import { useParams } from 'react-router'
import { Page, Header, SecaoGenerica, ModalConfirmacao, ModalAlerta, CustomButton } from 'components'
import { FileManager } from 'components/FileManager'
import { Grid, Typography, Divider, CircularProgress } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import useRouter from 'utils/useRouter'
import moment from 'moment'

import useStyles from './EditarPericiando.styles'
import { useFormPericiando } from './hooks/useFormPericiando'
import {
  FormDadosGerais,
  FormDadosQualificacao,
  FormDadosEndereco,
  FormOutrosDados
} from './components'

export const EditarPericiando = (props) => {
  const { route } = props
  const classes = useStyles()
  const params = useParams()
  const router = useRouter()

  const {
    periciando,
    processandoPericiando,
    processandoOperacao,
    arquivos,
    setArquivos,
    arquivosIniciais,
    paises,
    estados,
    cidades,
    cidadesNaturalidade,
    tipo,
    tipoPrisao,
    setTipoPrisao,
    categoriaPrisao,
    setCategoriaPrisao,
    naturezaSolicitacao,
    setNaturezaSolicitacao,
    arrayFiliacoesPericiando,
    formValido,
    openEspelhoConfirmacao,
    setOpenEspelhoConfirmacao,
    mensagensAlerta,
    openAlert,
    formPericiando,
    handleAdicionarFiliacao,
    handleSearchCep,
    handleChangeTipoPericiando,
    handleChangeNaturalidadeEstado,
    handleBotaoCadastrarEditar,
    handleCloseAlert,
    handleConfirmarOperacao,
    cpfMask,
    cepMask,
  } = useFormPericiando({
    route,
    idCaso: params.idCaso,
    idPericiando: params.id,
  })

  // Formatadores de visualização dos dados no espelho de confirmação
  const getEstadoCivilLabel = () => formPericiando.formState.values.estadoCivil || 'NÃO INFORMADO'

  const getNacionalidadeLabel = () => {
    const nac = formPericiando.formState.values.nacionalidade
    if (!nac) return 'NÃO INFORMADO'
    return typeof nac === 'object' ? (nac.nome || 'NÃO INFORMADO') : nac
  }

  const getNaturalidadeLabel = () => {
    const nat = formPericiando.formState.values.naturalidade
    if (!nat) return 'NÃO INFORMADO'
    return typeof nat === 'object' ? (nat.nome || 'NÃO INFORMADO') : nat
  }

  const getNaturalidadeCidadeLabel = () => {
    const cid = formPericiando.formState.values.naturalidadeCidade
    if (!cid) return 'NÃO INFORMADO'
    return typeof cid === 'object' ? (cid.nome || 'NÃO INFORMADO') : cid
  }

  const getCidadeEnderecoLabel = () => {
    const cid = formPericiando.formState.values.municipio
    if (!cid) return 'NÃO INFORMADO'
    return typeof cid === 'object' ? (cid.nome || 'NÃO INFORMADO') : cid
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {processandoPericiando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container style={{ marginTop: '16px' }}>
          {/* Seção 1: Dados Gerais */}


          <FormDadosGerais
            formPericiando={formPericiando}
            paises={paises}
            estados={estados}
            cidadesNaturalidade={cidadesNaturalidade}
            arrayFiliacoesPericiando={arrayFiliacoesPericiando}
            handleAdicionarFiliacao={handleAdicionarFiliacao}
            handleChangeNaturalidadeEstado={handleChangeNaturalidadeEstado}
            cpfMask={cpfMask}
            classes={classes}
          />

          <SecaoGenerica titulo="Dados da Qualificação" spacing={2}>
            <FormDadosQualificacao
              tipo={tipo}
              handleChangeTipoPericiando={handleChangeTipoPericiando}
              naturezaSolicitacao={naturezaSolicitacao}
              setNaturezaSolicitacao={setNaturezaSolicitacao}
              tipoPrisao={tipoPrisao}
              setTipoPrisao={setTipoPrisao}
              categoriaPrisao={categoriaPrisao}
              setCategoriaPrisao={setCategoriaPrisao}
              classes={classes}
            />
          </SecaoGenerica>

          <SecaoGenerica titulo="Dados de Endereço" spacing={2}>
            <FormDadosEndereco
              formPericiando={formPericiando}
              cidades={cidades}
              estados={estados}
              handleSearchCep={handleSearchCep}
              cepMask={cepMask}
              classes={classes}
            />
          </SecaoGenerica>

          <SecaoGenerica titulo="Outros Dados" spacing={2}>
            <FormOutrosDados
              formPericiando={formPericiando}
              classes={classes}
            />
          </SecaoGenerica>

          <SecaoGenerica titulo="Arquivos Relacionados" spacing={2}>

            <Grid item xs={12}>
              <FileManager
                rotaUpload="/arquivo/periciando"
                rotaLoadImagem="/arquivo/periciando"
                setArquivosPai={setArquivos}
                arquivosIniciais={arquivosIniciais}
                tipos={['pdf']}
              />
            </Grid>
          </SecaoGenerica>


          {/* Divisor do rodapé */}
          <Grid item xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>

          {/* Botões de Ação */}
          <Grid item xs={12}>
            <div className={classes.buttonGroup}>
              <CustomButton
                variant="outlined"
                colorType="primary"
                startIcon={<ArrowBackIcon />}
                onClick={() => router.history.goBack()}
              >
                Voltar
              </CustomButton>

              <CustomButton
                colorType="secondary"
                variant="contained"
                disabled={!formValido}
                isLoading={processandoOperacao}
                onClick={handleBotaoCadastrarEditar}
              >
                {route.editar ? 'Atualizar' : 'Cadastrar'}
              </CustomButton>
            </div>
          </Grid>
        </Grid>
      )}

      {/* Modal de Confirmação de Cadastro / Edição */}
      <ModalConfirmacao
        aberto={openEspelhoConfirmacao}
        onClose={() => setOpenEspelhoConfirmacao(false)}
        onConfirm={handleConfirmarOperacao}
        processando={processandoOperacao}
        titulo="Confirmação dos dados"
        confirmarLabel={route.editar ? 'Salvar' : 'Cadastrar'}
        cancelarLabel="Cancelar"
        maxWidth="md"
      >
        <Grid container spacing={2}>
          {/* Dados Gerais no Espelho */}


          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>CPF</Typography>
            <Typography variant="body1">
              {formPericiando.formState.values.cpf?.toUpperCase() || 'NÃO INFORMADO'}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>RG</Typography>
            <Typography variant="body1">
              {formPericiando.formState.values.rg?.toUpperCase() || 'NÃO INFORMADO'}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>DATA DE NASCIMENTO</Typography>
            <Typography variant="body1">
              {formPericiando.formState.values.dataNascimento
                ? moment(formPericiando.formState.values.dataNascimento).format('DD/MM/YYYY').toUpperCase()
                : 'NÃO INFORMADO'}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>ESTADO CIVIL</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {getEstadoCivilLabel()}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>NACIONALIDADE</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {getNacionalidadeLabel()}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>NATURALIDADE</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {`${getNaturalidadeLabel()} / ${getNaturalidadeCidadeLabel()}`}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>NOME</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {formPericiando.formState.values.nome || 'NÃO INFORMADO'}
            </Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <Typography className={classes.dadoEspelho}>ALCUNHA</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {formPericiando.formState.values.alcunha || 'NÃO INFORMADO'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.dadoEspelho}>FILIAÇÕES</Typography>
            <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
              {arrayFiliacoesPericiando
                ?.map((key) => formPericiando.formState.values[key])
                ?.filter(Boolean)
                ?.join(', ') || 'NÃO INFORMADO'}
            </Typography>
          </Grid>

          <SecaoGenerica titulo="Dados do Endereço" spacing={1}>
            <Grid item md={4} sm={4} xs={12}>
              <Typography className={classes.dadoEspelho}>CEP</Typography>
              <Typography variant="body1">
                {formPericiando.formState.values.cep?.toUpperCase() || 'NÃO INFORMADO'}
              </Typography>
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <Typography className={classes.dadoEspelho}>ENDEREÇO E NÚMERO</Typography>
              <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                {`${formPericiando.formState.values.endereco || 'NÃO INFORMADO'}, ${formPericiando.formState.values.numeroResidencial || 'NÃO INFORMADO'
                  }`}
              </Typography>
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <Typography className={classes.dadoEspelho}>BAIRRO, CIDADE E ESTADO</Typography>
              <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                {`${formPericiando.formState.values.bairro || 'NÃO INFORMADO'} - ${getCidadeEnderecoLabel()} / ${formPericiando.formState.values.estado || 'RN'
                  }`}
              </Typography>
            </Grid>
            <Grid item md={4} sm={4} xs={12}>
              <Typography className={classes.dadoEspelho}>COMPLEMENTO</Typography>
              <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                {formPericiando.formState.values.complemento || 'NÃO INFORMADO'}
              </Typography>
            </Grid>
          </SecaoGenerica>

          {/* Outros Dados no Espelho */}
          <Grid item xs={12}>
            <SecaoGenerica titulo="Outros Dados" spacing={1}>
              <Grid item md={4} sm={4} xs={12}>
                <Typography className={classes.dadoEspelho}>OCUPAÇÃO</Typography>
                <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                  {formPericiando.formState.values.ocupacao || 'NÃO INFORMADO'}
                </Typography>
              </Grid>
              <Grid item md={4} sm={4} xs={12}>
                <Typography className={classes.dadoEspelho}>ESCOLARIDADE</Typography>
                <Typography variant="body1" style={{ textTransform: 'uppercase' }}>
                  {formPericiando.formState.values.escolaridade || 'NÃO INFORMADO'}
                </Typography>
              </Grid>
            </SecaoGenerica>
          </Grid>
        </Grid>
      </ModalConfirmacao>

      {/* Modal de Alerta de Requisitos */}
      <ModalAlerta
        aberto={openAlert}
        onClose={handleCloseAlert}
        titulo="Não é possível realizar a operação"
        mensagens={mensagensAlerta}
        tipo="erro"
      />
    </Page>
  )
}
